<template>
  <v-dialog v-model="open" width="630px" scrollable>
    <v-card>
      <v-toolbar elevation="0">
        <v-tabs fixed-tabs v-model="configTab">
          <v-tab v-for="item in configTabs" :key="item.tab">
            {{ item.tab }}
          </v-tab>
        </v-tabs>
      </v-toolbar>
      <v-card-text style="height: 63vh" class="pl-7 pr-5 py-0">
        <drm-main-settings
          :handleCloseModal="handleClose"
          :drmGroup="drmGroup"
          v-show="configTab === 0"
        />
        <drm-screen-time
          :handleCloseModal="handleClose"
          :drmGroup="drmGroup"
          v-if="configTab === 1"
        />
        <drm-settings-style
          :handleCloseModal="handleClose"
          :drmGroup="drmGroup"
          v-if="configTab === 2"
        />
        <drm-advanced
          :handleCloseModal="handleClose"
          :drmGroup="drmGroup"
          v-if="configTab === 3"
        />
      </v-card-text>
    </v-card>
  </v-dialog>
</template>

<script>
import DrmMainSettings from './DrmMainSettings'
import DrmScreenTime from './DrmScreenTime'
import DrmSettingsStyle from './DrmSettingsStyle.vue'
import DrmAdvanced from './DrmAdvanced.vue'
import i18n from '@/translations/lang'

export default {
  name: 'DrmModalGroupSettings',
  components: {
    DrmMainSettings,
    DrmScreenTime,
    DrmSettingsStyle,
    DrmAdvanced,
  },
  props: {
    drmGroup: Object,
  },
  data: () => ({
    open: false,
    isFetching: false,
    drmValue: false,
    configTab: 0,
    configTabs: [],
  }),
  watch: {},
  mounted() {
    this.configTabs = [
      { tab: i18n.t('message.pages.drm.settings.tab1') },
      { tab: i18n.t('message.pages.drm.settings.tab2') },
      { tab: i18n.t('message.pages.drm.settings.tab3') },
      { tab: i18n.t('message.pages.drm.settings.tab4') },
    ]
    this.$root.$on('openDrmModalGroupSettings', (configTab) => {
      this.$root.$emit('resetDrmMainSettings')
      Object.assign(this.$data, this.initialState())
      this.open = true
      if (configTab) {
        this.configTab = configTab
      }
    })
  },
  beforeDestroy() {
    this.$root.$off('openDrmModalGroupSettings')
  },
  methods: {
    handleClose() {
      this.open = false
    },
    initialState() {
      return {
        open: false,
        isFetching: false,
        drmValue: false,
        configTab: 0,
        configTabs: [
          { tab: i18n.t('message.pages.drm.settings.tab1') },
          { tab: i18n.t('message.pages.drm.settings.tab2') },
          { tab: i18n.t('message.pages.drm.settings.tab3') },
          { tab: i18n.t('message.pages.drm.settings.tab4') },
        ],
        drmGroup: null,
      }
    },
  },
}
</script>

<style>
.cardTitle {
  font-weight: 600;
  font-size: 24px;
  line-height: 36px;
}
.v-dialog .v-sheet.v-card {
  overflow: visible !important;
}
</style>
